import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { t } from "@/i18n";

export const Field = ({ label, hint, children, className = "" }) => (
  <div className={`space-y-1.5 ${className}`}>
    <Label className="text-xs text-muted-foreground uppercase tracking-wider">{t(label)}</Label>
    {children}
    {hint && <p className="text-[11px] text-muted-foreground">{t(hint)}</p>}
  </div>
);

export const SimpleSelect = ({ value, onChange, options, placeholder = "Selecciona…", testId }) => (
  <Select value={value || ""} onValueChange={onChange}>
    <SelectTrigger data-testid={testId}><SelectValue placeholder={t(placeholder)} /></SelectTrigger>
    <SelectContent>
      {options.map((o) => {
        const [v, l] = Array.isArray(o) ? o : [o, o];
        return <SelectItem key={v} value={v} data-testid={`${testId}-option-${v}`}>{t(l)}</SelectItem>;
      })}
    </SelectContent>
  </Select>
);
